window.env = {
    API_URL: 'https://apitest.fincentive.co',
    API_URL_PROGRAMS: 'https://apitest.fincentive.co',
    EMAIL_SERVER: 'https://buy.fincentive.co/send-email',
    API_KEY: '61626364656639383736353433323130:eada923bad50b207c9a27678c2405b9b',
    API_SECRET: 'b5f51a24477b86046fd2835b0dab308314ac84f96b64b8f202c67e13c4104246',
    ICICI_INTERNAL_API_KEY: 'AKAKAKALKOIHIUH989'

  };
